/**
 * UranIA PA — `/console` (redirect a `/admin/piattaforma`).
 *
 * Fusione A.5 (Riordino della mappa delle rotte §4/§7): il contenuto vive
 * ora su `/admin/piattaforma` (`routes/admin/piattaforma/index.tsx`), come
 * sezione dell'hub admin invece che cruscotto a sé. Questa rotta resta
 * solo come redirect — preserva anche `?vista=` (chi arriva da un vecchio
 * link con `?vista=grafo`, o con l'id di una delle 13 aree, non perde il
 * contesto): `validateSearch` deve ripetere quello di
 * `admin/piattaforma/index.tsx` perché il tipo del redirect combaci.
 */

import { createRoute, redirect } from '@tanstack/react-router';

import { Route as AmministrazioneSegmentRoute } from './_amministrazione.tsx';

export const Route = createRoute({
  getParentRoute: () => AmministrazioneSegmentRoute,
  path: '/console',
  validateSearch: (search: Record<string, unknown>): { vista: string } => ({
    vista: typeof search.vista === 'string' ? search.vista : 'stato',
  }),
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/admin/piattaforma', search, replace: true });
  },
});
